import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button/Button';

import type IAnalysisResultCardFooter from './interfaces/IAnalysisResultCardFooter';

import styles from './sass/AnalysisResultCardFooter.module.scss';

function AnalysisResultCardFooter({
  isDetailsOpen,
  onToggleDetails,
  totalEntities,
  totalScenarios,
}: IAnalysisResultCardFooter): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerMeta}>
        <span>
          {totalEntities}
          {' '}
          {t('valueChainMap.resultCardEntities')}
        </span>
        <span className={styles.footerDot} aria-hidden="true">•</span>
        <span>
          {totalScenarios}
          {' '}
          {t('valueChainMap.resultCardScenarios')}
        </span>
      </div>
      <Button
        className={styles.viewDetailsButton}
        onClick={onToggleDetails}
        title={isDetailsOpen
          ? t('valueChainMap.resultCardHideDetails')
          : t('valueChainMap.resultCardViewDetails')}
      />
    </footer>
  );
}

export default AnalysisResultCardFooter;
